"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var gift_container_1 = __importDefault(require("../views/gift-container"));
var confetti_emitter_1 = __importDefault(require("../emitters/confetti-emitter"));
var color_1 = require("../utilities/color");
var stack_container_1 = __importStar(require("../views/stack-container"));
var game_area_1 = require("../utilities/game-area");
var color_filter_1 = __importDefault(require("../utilities/color-filter"));
var customize_1 = require("../models/customize");
var gsap_1 = require("gsap");
var i18next_1 = __importDefault(require("i18next"));
var GiftState = /** @class */ (function (_super) {
    __extends(GiftState, _super);
    function GiftState(app, client, backdropContainer, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._backdropContainer = backdropContainer;
        _this._dragonContainer = dragonContainer;
        return _this;
    }
    Object.defineProperty(GiftState.prototype, "giftContainer", {
        get: function () {
            if (!this._giftContainer) {
                this._giftContainer = new gift_container_1.default(this._app.loader.resources);
                this._giftContainer.on("pointerdown", this.openGift.bind(this));
                this._giftContainer.itemSlot.addChild(this.elementSprite);
            }
            return this._giftContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GiftState.prototype, "elementSprite", {
        get: function () {
            if (!this._elementSprite) {
                this._elementSprite = new PIXI.Sprite();
                this._elementSprite.width = 376;
                this._elementSprite.height = 376;
                this._elementSprite.anchor.set(0.5);
            }
            return this._elementSprite;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GiftState.prototype, "confettiEmitter", {
        get: function () {
            if (!this._confettiEmitter) {
                this._confettiEmitter = new confetti_emitter_1.default();
            }
            return this._confettiEmitter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GiftState.prototype, "titleLabel", {
        get: function () {
            if (!this._titleLabel) {
                this._titleLabel = new PIXI.Text("");
                this._titleLabel.style = {
                    fontFamily: "Arial",
                    fontWeight: "bold",
                    align: "center",
                    fontSize: 35,
                    fill: color_1.COLOR.WHITE
                };
            }
            return this._titleLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GiftState.prototype, "tipLabel", {
        get: function () {
            if (!this._tipLabel) {
                this._tipLabel = new PIXI.Text("");
                this._tipLabel.style = {
                    fontFamily: "Arial",
                    fontSize: 21,
                    fill: color_1.COLOR.GREEN
                };
            }
            return this._tipLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GiftState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.titleLabel,
                    this.tipLabel
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 6,
                    minWidth: game_area_1.GAME_WIDTH
                });
                this._stackContainer.position.set(0, game_area_1.GAME_SAFE_AREA.bottom - this._stackContainer.height - 10);
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GiftState.prototype, "gift", {
        get: function () {
            return this._gift;
        },
        set: function (value) {
            this._gift = value;
        },
        enumerable: false,
        configurable: true
    });
    GiftState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this._backdropContainer);
        this._app.stage.addChild(this.stackContainer);
        this._dragonContainer.setIdleAnimation();
        this._backdropContainer.dragonSlot.addChild(this._dragonContainer);
        this.giftContainer.interactive = true;
        this.giftContainer.setIdleAnimation();
        this._backdropContainer.giftSlot.addChild(this.giftContainer);
        this.giftContainer.confettiSlot.addChild(this.confettiEmitter.parent);
        this.titleLabel.text = i18next_1.default.t("gift_caption");
        this.tipLabel.text = i18next_1.default.t("gift_hint");
        this.stackContainer.layoutChildren();
        this.updateElement();
        this._client.sendEvent("gift_entered");
    };
    GiftState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this._backdropContainer);
        this._app.stage.removeChild(this.stackContainer);
        this._backdropContainer.dragonSlot.removeChild(this._dragonContainer);
        this.giftContainer.interactive = false;
        this._backdropContainer.giftSlot.removeChild(this.giftContainer);
        this.giftContainer.confettiSlot.removeChild(this.confettiEmitter.parent);
        this.confettiEmitter.emit = false;
        this.confettiEmitter.cleanup();
    };
    GiftState.prototype.updateElement = function () {
        var _a;
        var category = customize_1.CUSTOMIZE_CATEGORIES[this.gift.categoryID];
        var element = category.elements[this.gift.elementID];
        this.elementSprite.texture = this._app.loader.resources.ui.textures["customize_" + this.gift.categoryID + "_" + ((_a = element.resourceName) !== null && _a !== void 0 ? _a : this.gift.elementID) + ".png"];
        var color = element.color;
        if (element.colorCategory) {
            var colorID = this._client.dragon.appearance[element.colorCategory];
            var colorElement = customize_1.CUSTOMIZE_CATEGORIES[element.colorCategory].elements[colorID];
            color = colorElement.color;
        }
        this.elementSprite.filters = color ? [new color_filter_1.default(color)] : null;
    };
    GiftState.prototype.openGift = function () {
        var _this = this;
        this.giftContainer.interactive = false;
        var category = customize_1.CUSTOMIZE_CATEGORIES[this.gift.categoryID];
        var element = category.elements[this.gift.elementID];
        this._client.dragon.unlocks[this.gift.categoryID].push(this.gift.elementID);
        this._client.dragon.status.level = this.gift.level;
        this._client.synchronize();
        this._client.sendEvent("gift_finished", {
            gift: this.gift
        });
        this.titleLabel.text = i18next_1.default.t(this.gift.elementID);
        this.tipLabel.text = i18next_1.default.t("gift_finish_hint")
            .replace("[category]", i18next_1.default.t(this.gift.categoryID));
        this.stackContainer.layoutChildren();
        this.giftContainer.setOpenAnimation(function (on) {
            _this.confettiEmitter.emit = on;
        }, this.finish.bind(this));
    };
    GiftState.prototype.finish = function () {
        var _this = this;
        gsap_1.gsap.to(this, {
            duration: 2,
            onComplete: function () {
                _this.stateMachine.pop();
            }
        });
    };
    return GiftState;
}(state_1.default));
exports.default = GiftState;
